import { useEffect, useState, useRef, useContext } from "react";
import { ApartmentViewContext } from "../context/ApartmentViewContext";
import styles from "../../../styles/aprt.module.scss";

function PlanRendererArrangeMode({
  svgContent,
  apartmentData,
  userSelectedArrangements,
  // arrangementVersions, //pass as prop or get from apartmentData?
  // setUrlComboParam, //temp
  selectedCompartmentInd,
  hoveredCompartmentInd,
  setApartmentViewInteractions,
}) {
  const [modifiedSvgContent, setModifiedSvgContent] = useState(svgContent);
  const svgContainerRef = useRef(null);
  const {
    //temporary solution, TODO: refactor to use URL Params from react-router-dom
    setUrlComboParam, //temp
  } = useContext(ApartmentViewContext);

  const [compartmentVersionsSvgContent, setCompartmentVersionsSvgContent] =
    useState([]);

  const apartmentsTier = apartmentData.compartments.find(
    (compartment) => compartment.number === 1
  ).ref_tier;

  const getNumbersOfArrangementVersions = (apartmentData) => {
    const sortedCompartments = apartmentData.compartments.sort((a, b) => {
      return parseInt(a.number) - parseInt(b.number);
    });
    const arrangementVersions = sortedCompartments.map(
      (compartment) => compartment.versions
    );
    return arrangementVersions;
  };

  const arrangementVersions = getNumbersOfArrangementVersions(apartmentData);

  useEffect(() => {
    //TODO: this color fills are the same in other modes, maybe we should set them as default in the parent component and only change in modes that need it ?
    //TODO: check if not merge with useEffect to add listeners to paths
    if (!svgContent) return;

    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgContent, "image/svg+xml");
    const svgRoot = svgDoc.documentElement;

    /*
removed color fill changes as its done in parent component
*/

    const serializer = new XMLSerializer();
    const newSvgContent = serializer.serializeToString(svgDoc);
    setModifiedSvgContent(newSvgContent);
  }, [svgContent]);

  const handleRoomClickInArrangeMode = (ind) => {
    //TODO move to utils - the same function is in PlanRendererArrangeMode
    const clickedCompartmentIndex = ind - 1;
    const availableNumberOfVersions =
      arrangementVersions[clickedCompartmentIndex];

    //TODO: temporary, refactor to use URL Params from react-router-dom
    const currentArrangementSelection = userSelectedArrangements;

    const updateSelectionArray = (prev) => {
      const newArr = [...prev];
      newArr[clickedCompartmentIndex] =
        (newArr[clickedCompartmentIndex] + 1) % availableNumberOfVersions;

      return newArr;
    };

    const newArrangementSelection = updateSelectionArray(
      currentArrangementSelection
    );

    const encodeCombination = (
      //TEMPORARY FUNC DECLARATION - TODO: import from utils
      arrangementsArray,
      variantsPerElement
    ) => {
      let encodedValue = 0;
      for (let i = 0; i < arrangementsArray.length; i++) {
        let product = 1;
        for (let j = i - 1; j >= 0; j--) {
          product *= variantsPerElement[j];
        }
        encodedValue += arrangementsArray[i] * product;
      }
      return encodedValue;
    };

    const encodedCombination = encodeCombination(
      newArrangementSelection,
      arrangementVersions
    );

    setUrlComboParam(encodedCombination);
  };

  const handleRoomHover = (ind, isOnPath) => {
    //TODO: move this to utils
    ind === null
      ? setApartmentViewInteractions(
          ({ isCompartmentPathHovered, hoveredCompartmentInd, ...rest }) => ({
            isCompartmentPathHovered: false,
            hoveredCompartmentInd: null,
            ...rest,
          })
        )
      : setApartmentViewInteractions(
          ({ isCompartmentPathHovered, hoveredCompartmentInd, ...rest }) => ({
            isCompartmentPathHovered: isOnPath,
            hoveredCompartmentInd: ind,
            ...rest,
          })
        );
  };
  // const handleRoomClick = (ind) => {
  //   // selectedCompartmentInd === ind //TODO: something is not working here
  //   !ind
  //     ? setApartmentViewInteractions(({ selectedCompartmentInd, ...rest }) => ({
  //         selectedCompartmentInd: null,
  //         ...rest,
  //       }))
  //     : setApartmentViewInteractions(({ selectedCompartmentInd, ...rest }) => ({
  //         selectedCompartmentInd: ind,
  //         ...rest,
  //       }));
  // };

  useEffect(() => {
    //TODO BUG fIX: constant re-rendering after mouse click;
    const svgContainer = svgContainerRef.current;
    if (!svgContainer) return;

    const svgDoc = svgContainer.querySelector("svg");
    if (!svgDoc) return;

    const apartmentTierGroup = svgDoc.querySelector('g.apartment_tier');
    if (!apartmentTierGroup) return;
    
    const compartmentsGroup = apartmentTierGroup.querySelector('g.compartments');
    if (!compartmentsGroup) return;
    
    const compartmentPaths = compartmentsGroup.querySelectorAll(
      "path.compartment"
    );

    compartmentPaths.forEach((path) => {
      const compartmentNumber = Number(path.getAttribute("number"));
      //TODO: test listeners on mobile devices, maybe use onTouchStart instead of onClick
      path.addEventListener("click", () => handleRoomClickInArrangeMode(compartmentNumber));
      path.addEventListener("mouseenter", () =>
        handleRoomHover(compartmentNumber, true)
      );
      path.addEventListener("mouseleave", () => handleRoomHover(null, false));
    });

    return () => {
      compartmentPaths.forEach((path) => {
        const compartmentNumber = Number(path.getAttribute("number"));
        path.removeEventListener("click", () => handleRoomClickInArrangeMode());
        path.removeEventListener(
          "mouseenter",
          handleRoomHover(compartmentNumber, true)
        );
        path.removeEventListener("mouseleave", handleRoomHover(null, false));
      });
    };
  }, [modifiedSvgContent]);

  useEffect(() => {
    //TODO: check if not merge with above useEffect[svgContent]
    const svgContainer = svgContainerRef.current;
    if (!svgContainer) return;

    const svgDoc = svgContainer.querySelector("svg");
    if (!svgDoc) return;

    const apartmentTierGroup = svgDoc.querySelector('g.apartment_tier');
    if (!apartmentTierGroup) return;
    
    const compartmentsGroup = apartmentTierGroup.querySelector('g.compartments');
    if (!compartmentsGroup) return;
    
    const compartmentPaths = compartmentsGroup.querySelectorAll(
      "path.compartment"
    );

    compartmentPaths.forEach((path) => {
      const compartmentNumber = Number(path.getAttribute("number"));
      //TODO: test listeners on mobile devices, maybe use onTouchStart instead of onClick
      if (compartmentNumber === selectedCompartmentInd || compartmentNumber === hoveredCompartmentInd) {
        path.classList.add(`${styles.svg_path_highlighted}`);
      }
      if (compartmentNumber != selectedCompartmentInd && compartmentNumber != hoveredCompartmentInd) {
        path.classList.remove(`${styles.svg_path_highlighted}`);
      }
    });

  }, [selectedCompartmentInd, hoveredCompartmentInd]);

  return (
    <div
      ref={svgContainerRef}
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      dangerouslySetInnerHTML={{ __html: modifiedSvgContent }}
    />
  );
}

export default PlanRendererArrangeMode;
